// #ux-redesign-start: HelpMenu migrado de popup dropdown → Drawer derecho del DS
// Antes: <Dropdown> de Reactstrap con un Card flotante chico.
// Ahora: trigger ícono en navbar + Drawer DS (side="right", size="md") con todo
// el alto disponible, animación deslizante, backdrop, escape/click-outside.
// ─────────────────────────────────────────────────────────────────────────────

import React, { useState } from 'react';
import { useTranslate } from 'react-translate';

import Icon from 'components/Icons/Icon';
import { Drawer, EmptyState } from 'components/ds';
import useHelpKey from '../../../hooks/useHelpKey';

const HelpMenu = React.memo(({ activeRoute }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { text } = useHelpKey(activeRoute);
  const t = useTranslate('menu');
  const ta = useTranslate('a11y');

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <>
      <li className="nav-item help-menu" style={{ display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          onClick={open}
          aria-label={t('help')}
          aria-expanded={isOpen}
          style={{
            background: 'transparent',
            border: 'none',
            padding: '8px',
            cursor: 'pointer',
            color: 'var(--color-text-secondary)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '36px',
            height: '36px',
            borderRadius: 'var(--radius-md)',
            transition:
              'background-color var(--transition-fast), color var(--transition-fast)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--color-surface-sunken)';
            e.currentTarget.style.color = 'var(--color-text-primary)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'var(--color-text-secondary)';
          }}
        >
          <Icon file="help.svg" width="21px" title={ta('help')} />
        </button>
      </li>

      <Drawer
        isOpen={isOpen}
        onClose={close}
        title={t('help')}
        side="right"
        size="md"
        backdropTestId="help_popup"
      >
        {text && String(text).trim() ? (
          <div
            className="help_content"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ) : (
          // #ux-redesign: fallback explícito — si una ruta no tiene contenido
          // de ayuda cargado, mostramos un estado vacío en vez de un panel en
          // blanco que parece roto.
          <EmptyState
            icon={
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            }
            title={t('help-empty-title')}
            description={t('help-empty-description')}
          />
        )}
      </Drawer>
    </>
  );
});

export default HelpMenu;
// #ux-redesign-end
